/* Editor-owned articles retain the approved reading layout and a current outline. */
(() => {
  'use strict';
  const body = document.querySelector('[data-pc-live-article="true"]');
  if (!body) return;
  const nav = document.querySelector('[data-pc-article-toc]');
  if (!nav) return;
  const headings = [...body.querySelectorAll('h2')].filter(h => h.textContent.trim());
  nav.replaceChildren();
  if (!headings.length) {
    nav.closest('.article-sidebar').hidden = true;
    body.closest('.article-reading').classList.add('no-toc');
    return;
  }
  const used = new Set([...document.querySelectorAll('[id]')].filter(el => !headings.includes(el)).map(el => el.id));
  headings.forEach((heading, index) => {
    let id = heading.id || `article-section-${index + 1}`;
    while (used.has(id)) id += '-section';
    used.add(id); heading.id = id; heading.tabIndex = -1;
    const a = document.createElement('a'); a.href = '#' + encodeURIComponent(id); a.textContent = heading.textContent;
    a.addEventListener('click', () => {
      nav.querySelectorAll('[aria-current]').forEach(link => link.removeAttribute('aria-current'));
      a.setAttribute('aria-current', 'location');
      heading.focus({preventScroll: true});
    });
    nav.append(a);
  });
})();
